import script from "./ExRes.vue?vue&type=script&setup=true&lang=js"
export * from "./ExRes.vue?vue&type=script&setup=true&lang=js"

import "./ExRes.vue?vue&type=style&index=0&id=85f43dda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85f43dda"]])

export default __exports__